import React from "react";
import { connect } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle, faRedo, faHeadset, faHome } from "@fortawesome/free-solid-svg-icons";
import { confirmCartApi } from "../../services/api.services";
import "./Checkout.page.css";

function PaymentCancelledPage(props) {
  const navigate = useNavigate();
  const { isAuthenticated } = props;
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("order_id");
  const [retrying, setRetrying] = React.useState(false);

  const handleRetry = async () => {
    if (!orderId) return;
    setRetrying(true);
    try {
      const res = await confirmCartApi({ order_id: orderId, retry: true });
      if (res.status === 200 && res.data?.payment_url) {
        window.location.href = res.data.payment_url;
      }
    } catch { /* ignore */ }
    finally {
      setRetrying(false);
    }
  };

  return (
    <div className="co-page">
      <div className="co-layout" style={{ justifyContent: "center" }}>
        <div className="co-main" style={{ maxWidth: "500px", textAlign: "center", paddingTop: "40px" }}>
          <FontAwesomeIcon
            icon={faTimesCircle}
            style={{ fontSize: "4rem", color: "#dc3545", marginBottom: "20px" }}
          />
          <h2 style={{ fontWeight: 700, color: "#222", marginBottom: "8px" }}>
            Pagamento non completato
          </h2>
          {orderId && (
            <p style={{ color: "#888", fontSize: "0.95rem", marginBottom: "24px" }}>
              Ordine: <strong>#{orderId}</strong>
            </p>
          )}

          <div className="co-card" style={{ textAlign: "left", marginBottom: "20px" }}>
            <p style={{ color: "#555", fontSize: "0.92rem", lineHeight: 1.6 }}>
              Il pagamento non è andato a buon fine. Puoi riprovare il pagamento
              oppure contattare l'assistenza per ricevere aiuto.
            </p>
          </div>

          <div style={{ display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap" }}>
            <button
              className="up-btn up-btn--primary"
              onClick={handleRetry}
              disabled={retrying}
            >
              <FontAwesomeIcon icon={faRedo} style={{ marginRight: "6px" }} />
              {retrying ? "Riprovando..." : "Riprova il pagamento"}
            </button>
            {isAuthenticated && (
              <button
                className="up-btn up-btn--outline"
                onClick={() => navigate("/profilo/assistenza")}
              >
                <FontAwesomeIcon icon={faHeadset} style={{ marginRight: "6px" }} />
                Contatta assistenza
              </button>
            )}
            <button
              className="up-btn up-btn--ghost"
              onClick={() => navigate("/leaflet")}
            >
              <FontAwesomeIcon icon={faHome} style={{ marginRight: "6px" }} />
              Torna al volantino
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.authJWT.isAuthenticated,
});

export default connect(mapStateToProps)(PaymentCancelledPage);
